import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "../../authentications/SessionContext";

function PublicRouter() {
  const prevRoute = localStorage.getItem("lastVisitedRoute");

  const { authenticated } = useSession();
  if (authenticated) {
    if (prevRoute?.includes("homepage")) {
      return <Navigate replace to={prevRoute} />;
    } else {
      return <Navigate replace to="/homepage" />;
    }
  }

  return <Outlet />;
}

export default PublicRouter;
